import React from 'react';
import { RoutePermittedRole } from '../../constants/AppEnums';

const Seller = React.lazy(() => import('../../../modules/seller'));
export const sellerRouteConfig = [
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/seller',
    element: <Seller />,
  },
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/seller/type/:type',
    element: <Seller />,
  },
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/seller/:id',
    element: <Seller />,
  }
];
